import {MouseEventHandler, useState, useEffect, useRef} from "react";
import blackCloseIcon from '../../../images/black-close-icon.svg';

import * as Styled from './CommentBlockStyles';
import OutsideAlerter from "../../hooks/OutsideAlerter";

interface CommentBlockProps{
  onDismiss: MouseEventHandler;
  onSubmit: Function;
  isLike: boolean;
}
const initialPos:any = {
  top: 'auto',
  bottom: 'auto',
  visibility: 'hidden',
}
const CommentBlock = ({ onDismiss, onSubmit, isLike}: CommentBlockProps) => {
  const [comment, setComment] = useState('');
  const [pos, setPos] = useState(initialPos);
  const blockRef = useRef(null);
  const updateComment = (e:any) => {
    setComment(e.currentTarget.value);
  }

  const submitComment = () => {
    onSubmit(comment);
  }

  useEffect(() => {
    if (blockRef.current) {
      // @ts-ignore
      const p = blockRef.current.getBoundingClientRect();
      if ((p.bottom + 40) > window.innerHeight) {
        setPos({top: 'auto', bottom: 20, visibility: 'visible' })
      } else {
        setPos({top: 40, bottom: 'auto', visibility: 'visible' })
      }
    }
  }, [blockRef]);


  return (
    <OutsideAlerter setFunction={onDismiss}>
      <Styled.Wrapper ref={blockRef} style={pos}>
        <Styled.Close onClick={onDismiss}>
          <Styled.Img src={blackCloseIcon} />
        </Styled.Close>

        <Styled.StyledParagraph>
          {isLike ?
            'Share with us if you have additional feedback on the thumbs up.'
            :
            'Share with us why this is a thumbs down for improvement!'
          }
        </Styled.StyledParagraph>
        <Styled.Textarea value={comment} onChange={updateComment} />
        <Styled.StyledBtn variant='primary' onClick={submitComment} >
          Submit
        </Styled.StyledBtn>
      </Styled.Wrapper>
    </OutsideAlerter>
  )
}

export default CommentBlock;